


































































import Vue, { PropType } from 'vue';
// import { BoothData } from '@/modules/exhibitor/booth';
// import {
//   BoothData,
// } from 'mostra';

interface DataType {
  isShowPreview1: boolean;
  isShowPreview2: boolean;
  isShowPreview3: boolean;
}

export default Vue.extend({
  name: 'GBoothTemplateList',
  props: {
    value: {
      type: Number as PropType<number>,
      default: null,
    },
    onSelectTemplate: {
      type: Function as PropType<() => void>,
      default: null,
    },
  },
  data(): DataType {
    return {
      isShowPreview1: false,
      isShowPreview2: false,
      isShowPreview3: false,
    };
  },
  computed: {
    innerValue: {
      get(): number {
        return this.value;
      },
      set(val: number): void {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    onInnerSelectTemplate(id: number) {
      return () => {
        this.innerValue = id;
        if (this.onSelectTemplate) {
          this.onSelectTemplate();
        }
      };
    },
    onClickPreview(template: string) {
      return () => {
        this[template] = true;
      };
    },
    onClosePreview(template: string) {
      return () => {
        this[template] = false;
      };
    },
  },
});
